export const CLASS_CHAT_HISTORY_ID = "class-chat-history";
export const CHAT_MESSAGE_VISIBILITY_THRESHOLD = 0.5;
export const RECENT_MESSAGE_HOURS = 16;
